/**
 * Single source of truth for the US phone rule the form enforces.
 *
 * Accepts anything the PhoneNumber input can produce — "(617) 555-1234",
 * "+1(617) 555-1234", raw digits — and reduces it to bare digits before
 * checking. Ten digits that do not start with 1 is the whole rule; the
 * leading-1 case is rejected because it means the country code was typed
 * without the "+" and the remaining nine digits are not a full number.
 *
 * @param {string} [value] - Phone number as typed
 * @returns {boolean} true when the value is a valid US phone number
 */
const isValidUsPhone = (value) => {
  const digits = value?.replace('+1', '')?.replace(/[\W_]/g, '') || ''
  return digits.length === 10 && digits[0] !== '1'
}

export default isValidUsPhone
